/* infinite-qty.js — Turbo + Infinite Options (oeil_gauche / oeil_droit) — v5
   - Message SOUS les 2 sélecteurs
   - Quantité auto: 1 si OG=OD, 2 sinon
   - Affiche un "Total estimé" sur la PDP (prix x quantité)
   - Panier/Drawer : impossible de descendre < 2 quand OG≠OD (désactivation + anti-bypass réseau)
*/
(function () {
  /* Langue du site (attribut lang de <html>) : textes FR par defaut, IT si it */
  const IT_LANG = (document.documentElement.lang || '').toLowerCase().indexOf('it') === 0;
  const SCRIPT_SRC = (document.currentScript && document.currentScript.src) || '';
  /* ====== helpers champs ====== */
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }
  const normalize = v => (v || '').toString().trim();
  function getLeftField(scope) {
    const r = scope || document;
    return q('[name="properties[oeil_gauche]"]', r)
        || q('[name="oeil_gauche"]', r)
        || q('.product-option-custom.mood-eye-left select, .product-option-custom.mood-eye-left input', r)
        || q('[name="properties[oeil_gauche]"], [name="oeil_gauche"], .product-option-custom.mood-eye-left select, .product-option-custom.mood-eye-left input');
  }
  function getRightField(scope) {
    const r = scope || document;
    return q('[name="properties[oeil_droit]"]', r)
        || q('[name="oeil_droit"]', r)
        || q('.product-option-custom.mood-eye-right select, .product-option-custom.mood-eye-right input', r)
        || q('[name="properties[oeil_droit]"], [name="oeil_droit"], .product-option-custom.mood-eye-right select, .product-option-custom.mood-eye-right input');
  }
  function getQtyInput(form) {
    return q('input[name="quantity"], input[id*="quantity"]', form);
  }
  function computeQty(l, r) {
    const L = normalize(l), R = normalize(r);
    if (!L || !R) return 1;
    return L === R ? 1 : 2;
  }
  function commonAncestor(a, b) {
    if (!a || !b) return null;
    const set = new Set(); let n = a;
    while (n) { set.add(n); n = n.parentElement; }
    n = b; while (n) { if (set.has(n)) return n; n = n.parentElement; }
    return null;
  }

  /* ====== PDP: message + total ====== */
  function ensureHintAfterWrapper(form) {
    const leftWrap  = q('.product-option-custom.mood-eye-left', form)  || getLeftField(form)?.closest('.product-option-custom') || getLeftField(form)?.closest('div');
    const rightWrap = q('.product-option-custom.mood-eye-right', form) || getRightField(form)?.closest('.product-option-custom') || getRightField(form)?.closest('div');
    const wrapper = commonAncestor(leftWrap, rightWrap) || form;

   let hint = document.getElementById('ogod-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.id = 'ogod-hint';
      hint.className = 'ogod-hint';
      hint.innerHTML =
        '<div class="ogod-lines">' +

          '<div class="ogod-line">' +
            '<svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="11.5" cy="11.5" r="11.5" fill="#172D47"/>' +
              '<path d="M15.269 8.34631C15.4325 8.15471 15.6669 8.03247 15.9221 8.00559C16.1773 7.97872 16.4333 8.04935 16.6356 8.20243C16.7349 8.27689 16.8178 8.36987 16.8794 8.47588C16.9409 8.58188 16.9799 8.69875 16.9941 8.81959C17.0082 8.94043 16.9971 9.06279 16.9615 9.17942C16.926 9.29605 16.8666 9.4046 16.787 9.49865L11.6124 15.6534C11.5258 15.7551 11.4184 15.8382 11.2969 15.8977C11.1753 15.9571 11.0424 15.9915 10.9065 15.9986C10.7705 16.0057 10.6345 15.9855 10.5071 15.9391C10.3796 15.8928 10.2635 15.8213 10.166 15.7293L6.28514 12.0391L6.2177 11.9699C5.90668 11.6075 5.9287 11.0733 6.28514 10.7349C6.64158 10.3965 7.20444 10.3752 7.58565 10.671L7.65859 10.7349L10.7826 13.6924L15.2828 8.3503L15.269 8.34631Z" fill="white"/>' +
            '</svg>' +
            (IT_LANG ? '<span>Correzioni uguali:&nbsp <strong> verrà aggiunta 1 confezione</strong></span>' : '<span>Corrections identiques :&nbsp <strong> 1 boîte sera ajoutée</strong></span>') +
          '</div>' +

          '<div class="ogod-line">' +
            '<svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<circle cx="11.5" cy="11.5" r="11.5" fill="#172D47"/>' +
              '<path d="M12.888 9.41434L9.22393 9.82461L9.09273 10.3678L9.81274 10.4865C10.2831 10.5865 10.3759 10.7381 10.2735 11.1569L9.09273 16.1145C8.78232 17.3967 9.26073 18 10.3856 18C11.2576 18 12.2704 17.6398 12.7296 17.1452L12.8704 16.5505C12.5504 16.8021 12.0832 16.9021 11.7728 16.9021C11.3328 16.9021 11.1728 16.6262 11.2864 16.1402L12.888 9.41434ZM13 6.42951C13 6.80864 12.8314 7.17225 12.5314 7.44033C12.2313 7.70842 11.8243 7.85903 11.4 7.85903C10.9756 7.85903 10.5686 7.70842 10.2686 7.44033C9.96851 7.17225 9.79994 6.80864 9.79994 6.42951C9.79994 6.05038 9.96851 5.68678 10.2686 5.41869C10.5686 5.15061 10.9756 5 11.4 5C11.8243 5 12.2313 5.15061 12.5314 5.41869C12.8314 5.68678 13 6.05038 13 6.42951Z" fill="white"/>' +
            '</svg>' +
            (IT_LANG ? '<span>Correzioni diverse:&nbsp <strong> verranno aggiunte 2 confezioni (una per occhio)</strong></span>' : '<span>Corrections différentes :&nbsp <strong> 2 boîtes seront ajoutées (une par œil)</strong></span>') +
          '</div>' +

        '</div>';
      if (wrapper.nextSibling) { wrapper.parentNode.insertBefore(hint, wrapper.nextSibling); }
      else { wrapper.parentNode.appendChild(hint); }
    }
    return hint;
  }

  function readUnitPriceCents(form) {
    // 1) data-attributes (les thèmes sérieux exposent un prix en cents)
    const d = q('[data-product-price],[data-price],[data-product-price-cents]', form) || q('[data-product-price],[data-price],[data-product-price-cents]');
    if (d) {
      const val = d.getAttribute('data-product-price') || d.getAttribute('data-price') || d.getAttribute('data-product-price-cents');
      if (val && /^\d+$/.test(val)) return parseInt(val,10);
    }
    // 2) texte du prix (fallback)
    const moneyEl = q('.product__price .money, .product__price, .price .money, .price', form) || q('.product__price .money, .product__price, .price .money, .price');
    if (!moneyEl) return null;
    const txt = (moneyEl.textContent || '').trim();
    const digits = txt.replace(/[^\d,\.]/g, '');
    if (!digits) return null;
    // on prend le dernier séparateur comme décimal
    const m = digits.match(/^(.*?)([.,])(\d{1,2})$/);
    if (m) {
      const intPart = (m[1] || '').replace(/[^\d]/g, '');
      const dec = (m[3] || '00').padEnd(2,'0').slice(0,2);
      return (parseInt(intPart||'0',10) * 100) + parseInt(dec,10);
    }
    // pas de décimales visibles ⇒ on assume entiers
    const intOnly = digits.replace(/[^\d]/g,'');
    if (!intOnly) return null;
    return parseInt(intOnly,10) * 100;
  }

  function formatMoney(cents) {
    const fmt = document.body?.dataset?.moneyFormat || '{{amount}}';
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, fmt);
    // fallback simple (EUR)
    return (cents/100).toFixed(2) + ' €';
  }

// function updatePdpState(form) {
//   const left  = getLeftField(form) || getLeftField();
//   const right = getRightField(form) || getRightField();
//   if (!left || !right) return;

//   const L = normalize(left.value);
//   const R = normalize(right.value);
//   const diffCorrection = L && R && L !== R;

//   const qtyInput = getQtyInput(form);

//   if (qtyInput) {
//     if (diffCorrection) {
//       qtyInput.min  = '2';
//       qtyInput.step = '2';
//       let current = parseInt(qtyInput.value, 10) || 2;
//       if (current < 2) current = 2;
//       if (current % 2 !== 0) current += 1;

//       const nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
//       nativeSetter.call(qtyInput, String(current));
//       qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
//       qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

//       const minusBtn = qtyInput.closest('quantity-input')?.querySelector('[name="minus"]');
//       if (minusBtn) minusBtn.classList.toggle('disabled', current <= 2);
//     } else {
//       qtyInput.min  = '1';
//       qtyInput.step = '1';
//       const minusBtn = qtyInput.closest('quantity-input')?.querySelector('[name="minus"]');
//       if (minusBtn) minusBtn.classList.remove('disabled');
//     }
//   }

//   ensureHintAfterWrapper(form);

//   // ✅ Notify buy-buttons to update price
//   document.dispatchEvent(new CustomEvent('osr:qty-updated', { bubbles: true }));
// }

function updatePdpState(form) {
  const left  = getLeftField(form) || getLeftField();
  const right = getRightField(form) || getRightField();
  if (!left || !right) return;

  // Sirf hint show karo — qty ab buy-buttons.liquid handle karta hai
  ensureHintAfterWrapper(form);
}

  function wirePdpForm(form) {
    if (form.dataset.ogodQtyInit === 'true') return;
    form.dataset.ogodQtyInit = 'true';
    updatePdpState(form);

    document.addEventListener('change', function(ev){
      const t = ev.target;
      if (!t) return;
      if (
        t.matches('[name="properties[oeil_gauche]"], [name="oeil_gauche"], .product-option-custom.mood-eye-left select, .product-option-custom.mood-eye-left input') ||
        t.matches('[name="properties[oeil_droit]"],  [name="oeil_droit"],  .product-option-custom.mood-eye-right select, .product-option-custom.mood-eye-right input') ||
        t.matches('input[name="quantity"]')
      ) {
        updatePdpState(form);
      }
    });

    form.addEventListener('submit', function(){ updatePdpState(form); }, true);
  }

  function initPdp() {
    qa('form[action*="/cart/add"]').forEach(wirePdpForm);
  }

  /* ====== Panier/Drawer : anti < 2 en dur ====== */

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }
  async function changeLineQtyByKey(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
  }
  function needsMin2(item) {
    const og = normalize(item.properties && item.properties.oeil_gauche);
    const od = normalize(item.properties && item.properties.oeil_droit);
    return og && od && og !== od;
  }

  // 1) Désactiver visuellement les boutons "−" sur les lignes concernées
  async function markCartRows() {
    try {
      const cart = await fetchCart();
      (cart.items||[]).forEach(item => {
        if (!needsMin2(item)) return;
        // marque les lignes par leur "key" si présent dans DOM
        const sel = `[data-cart-item-key="${CSS.escape(item.key)}"], [data-line-item-key="${CSS.escape(item.key)}"], [data-item-key="${CSS.escape(item.key)}"], [data-key="${CSS.escape(item.key)}"]`;
        const rows = qa(sel);
        rows.forEach(row => {
          row.setAttribute('data-min-qty', '2');
          const minus = row.querySelector('button[name="minus"], button[data-action="decrease-quantity"], .ajaxcart__qty-adjust--minus, [data-quantity-change="-1"], .quantity__button--minus, .js-qty__adjust--minus');
          if (minus) minus.disabled = true;
          const qtyInput = row.querySelector('input[name^="updates"], input.qty, input[name="quantity"], .ajaxcart__qty-num, .quantity__input, .js-qty__num');
          if (qtyInput) qtyInput.min = 2;
        });
      });
    } catch(e){}
  }

  // 2) Bloquer toute tentative côté réseau (ANTI-BYPASS)
  (function hardenFetch() {
    if (!window.fetch) return;
    const orig = window.fetch.bind(window);
    window.fetch = async function(input, init) {
      try {
        const url = typeof input === 'string' ? input : (input && input.url);
        const isChange = url && /\/cart\/(change|update)\.js/.test(url);
        if (isChange && init && init.body) {
          let bodyObj = null;
          try { bodyObj = typeof init.body === 'string' ? JSON.parse(init.body) : init.body; } catch(e){}
          if (bodyObj && typeof bodyObj === 'object') {
            const cart = await fetchCart();
            let targetItem = null;
            if (bodyObj.id) {
              targetItem = (cart.items||[]).find(i => i.key === bodyObj.id || i.id === bodyObj.id || i.variant_id === bodyObj.id);
            } else if (bodyObj.updates) {
              // cas /cart/update.js avec "updates": {key: qty}
              const key = Object.keys(bodyObj.updates)[0];
              targetItem = (cart.items||[]).find(i => i.key === key);
              if (targetItem && needsMin2(targetItem) && bodyObj.updates[key] < 2) {
                bodyObj.updates[key] = 2;
                init.body = JSON.stringify(bodyObj);
              }
            }
            if (targetItem && needsMin2(targetItem) && typeof bodyObj.quantity !== 'undefined' && bodyObj.quantity < 2) {
              bodyObj.quantity = 2;
              init.body = JSON.stringify(bodyObj);
            }
          }
        }
      } catch(e) {}
      const res = await orig(input, init);
      // après chaque modif panier, re-marque les lignes
      try {
        if (typeof input === 'string' && /\/cart\/(change|add|update)\.js/.test(input)) {
          setTimeout(markCartRows, 50);
        }
      } catch(e){}
      return res;
    };
  })();

  // 3) Délégation de clic "−" (au cas où) : bloque si data-min-qty
  document.addEventListener('click', function(ev){
    const target = ev.target.closest('button[name="minus"], button[data-action="decrease-quantity"], .ajaxcart__qty-adjust--minus, [data-quantity-change="-1"], .quantity__button--minus, .js-qty__adjust--minus');
    if (!target) return;
    const row = target.closest('[data-cart-item-key], [data-line-item-key], [data-item-key], [data-key], .cart__row, .cart-item, li.cart__item, .ajaxcart__product');
    if (row && row.getAttribute('data-min-qty') === '2') {
      const qtyInput = row.querySelector('input[name^="updates"], input.qty, input[name="quantity"], .ajaxcart__qty-num, .quantity__input, .js-qty__num');
      const current = qtyInput ? parseInt(qtyInput.value,10) : 2;
      if (current <= 2) {
        ev.preventDefault(); ev.stopPropagation(); return false;
      }
    }
  }, true);

  function initCartGuards() {
    markCartRows();
    document.addEventListener('cart:refresh', markCartRows);
    document.addEventListener('ajaxCart.afterCartLoad', markCartRows);
    document.addEventListener('shopify:section:load', markCartRows);
    const mo = new MutationObserver(() => markCartRows());
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', () => setTimeout(markCartRows, 200));
  }


  /* ====== traduction IT des menus Infinite Options et du widget Appstle ======
     L'app injecte ses libelles en francais apres le chargement : sur le site
     italien on remplace les textes visibles. Les noms des champs
     (oeil_gauche / oeil_droit) ne changent pas. */
  const IT_TEXTES = [
    [/(?:Œ|Oe|oe|œ)il\s+droit/gi, 'Occhio destro'],
    [/(?:Œ|Oe|oe|œ)il\s+gauche/gi, 'Occhio sinistro'],
    [/Ce champ est (?:obligatoire|requis)/gi, 'Questo campo è obbligatorio'],
    [/Veuillez (?:s[ée]lectionner|choisir)/gi, 'Seleziona'],
    [/S[ée]lectionnez(?: votre| une| la)?/gi, 'Seleziona'],
    [/Choisissez(?: votre| une| la)?/gi, 'Scegli'],
    [/\bChoisir\b/gi, 'Scegli'],
    [/Sans correction/gi, 'Senza correzione'],
    [/\bCorrection\b/g, 'Correzione'],
    [/\bcorrection\b/g, 'correzione'],
    [/\bPuissance\b/g, 'Potere'],
    [/\bpuissance\b/g, 'potere'],
    [/\(obligatoire\)|\(requis\)/gi, '(obbligatorio)']
  ];
  /* Widget d'abonnement Appstle : libelles reglés dans l'app, en francais seulement */
  const IT_APPSTLE = [
    [/Options d['’]achat/g, 'Opzioni di acquisto'],
    [/Achat unique/g, 'Acquisto singolo'],
    [/Abonnement s[ée]lectionn[ée]/g, 'Abbonamento selezionato'],
    [/Abonnez-vous et [ée]conomisez/gi, 'Abbonati e risparmia'],
    [/Abonnement non disponible/g, 'Abbonamento non disponibile'],
    [/\bAbonnement\b/g, 'Abbonamento'],
    [/ÉCONOMISEZ/g, 'RISPARMIA'],
    [/[ÉE]conomisez/g, 'Risparmia'],
    [/Envoi tous les 3 mois/g, 'Spedizione ogni 3 mesi'],
    [/ à chaque commande/g, ' su ogni ordine'],
    [/100% flexible, /g, '100% flessibile, '],
    [/sans engagement annulable en 1 clic/g, 'senza vincoli, disdici in 1 clic'],
    [/Livraison offerte/g, 'Spedizione gratuita'],
    [/Recevez vos lentilles automatiquement/g, 'Ricevi le tue lenti in automatico'],
    [/, sans y penser/g, ', senza pensarci'],
    [/\/livraison/g, '/consegna'],
    [/Rupture de stock/g, 'Esaurito']
  ];
  /* Pastilles StarApps (étuis, nettoyeurs) : groupe et valeurs saisis en francais dans l'app.
     Valeurs remplacees seulement en fin de texte (seules ou apres « : ») */
  const IT_COULEURS = {
    'bambou': 'Bambù', 'taupe': 'Tortora', 'anthracite': 'Antracite', 'acajou': 'Mogano', 'rose': 'Rosa', 'jaune': 'Giallo', 'vert': 'Verde',
    'bleu ciel': 'Azzurro Cielo', 'bleu vif': 'Blu Intenso', 'gris perle': 'Grigio Perla', 'vert jade': 'Verde Giada',
    'vert opaline': 'Verde Opale', 'marron noisette': 'Nocciola', 'noisette': 'Nocciola'
  };
  const IT_SWATCHES = [
    [/\bcouleur\s*:/gi, 'Colore:'],
    [/\bcouleur\b/gi, 'Colore'],
    [/(^\s*|:\s*)(bleu ciel|bleu vif|gris perle|vert jade|vert opaline|marron noisette|noisette|bambou|taupe|anthracite|acajou|rose|jaune|vert)(\s*)$/i, function (m, avant, mot, apres) {
      return avant + IT_COULEURS[mot.toLowerCase().replace(/\s+/g, ' ')] + apres;
    }]
  ];
  function traduireTexte(t, table) {
    let r = t;
    (table || IT_TEXTES).forEach(function (p) { r = r.replace(p[0], p[1]); });
    return r;
  }
  function traduireOptions(root, table) {
    if (!IT_LANG || !root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      const v = n.nodeValue;
      if (v && v.trim()) {
        const t = traduireTexte(v, table);
        if (t !== v) n.nodeValue = t;
      }
    }
    qa('[placeholder], [aria-label]', root).forEach(function (el) {
      ['placeholder', 'aria-label'].forEach(function (a) {
        const v = el.getAttribute(a);
        if (v) { const t = traduireTexte(v, table); if (t !== v) el.setAttribute(a, t); }
      });
    });
  }
  function initTraductionOptions() {
    if (!IT_LANG) return;
    const SEL = '#infiniteoptions-container, .product-option-custom, [id^="infiniteoptions"], [class*="infiniteoptions"]';
    const SEL_APPSTLE = '[class*="appstle"], [id*="appstle"]';
    const passe = function () {
      qa(SEL).forEach(function (el) { traduireOptions(el, IT_TEXTES); });
      qa(SEL_APPSTLE).forEach(function (el) { traduireOptions(el, IT_APPSTLE); });
      qa('.swatches, [class*="swatches-type"]').forEach(function (el) { traduireOptions(el, IT_SWATCHES); });
    };
    passe();
    let attente = null;
    const mo = new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () { attente = null; passe(); }, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('load', function () { setTimeout(passe, 300); });
  }

  /* ====== site IT : avis Judge.me traduits + liens réservés à la France ======
     Les traductions sont dans assets/avis-it.js, par identifiant d'avis.
     Un nouvel avis reste dans sa langue d'origine tant qu'il n'est pas ajouté au fichier. */
  function normTxt(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  /* Widget v3 : Judge.me affiche les avis depuis jdgm.data, on traduit les données avant l'affichage */
  function traduireDonneesAvis() {
    const avis = window.OSR_AVIS_IT;
    const data = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
    if (!avis || !data) return;
    Object.keys(data).forEach(function (pid) {
      (data[pid].reviews || []).forEach(function (r) {
        const tr = avis[r.uuid];
        if (!tr) return;
        if (tr[0]) r.title = tr[0];
        r.body_html = tr[1];
        r.body = tr[1].replace(/<[^>]+>/g, '');
      });
    });
  }
  /* Puis, quel que soit le balisage, on remplace les textes français déjà affichés */
  function traduireTextesAvis(root) {
    const txt = window.OSR_AVIS_IT_TXT;
    if (!txt || !root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      const v = normTxt(n.nodeValue);
      if (!v || !Object.prototype.hasOwnProperty.call(txt, v)) continue;
      // textes courts (« Top », « Super ») : seulement dans un bloc d'avis
      if (v.length < 25) {
        const p = n.parentElement && n.parentElement.closest('[class*="jdgm"], [class*="judgeme"], [class*="jm-"], [data-review-id]');
        if (!p) continue;
      }
      n.nodeValue = txt[v];
    }
    root.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) traduireTextesAvis(el.shadowRoot); });
  }
  function appliquerAvisIt() {
    const avis = window.OSR_AVIS_IT;
    if (!avis) return;
    traduireDonneesAvis();
    qa('[data-review-id]').forEach(function (rev) {
      const tr = avis[rev.getAttribute('data-review-id')];
      if (!tr || rev.dataset.osrIt === '1') return;
      const titre = rev.querySelector('.jdgm-rev__title');
      const corps = rev.querySelector('.jdgm-rev__body');
      if (titre && tr[0]) titre.textContent = tr[0];
      if (corps) corps.innerHTML = tr[1];
      rev.dataset.osrIt = '1';
    });
    traduireTextesAvis(document.body);
  }
  /* Marque sur le site italien : Mood Lenti (textes affichés par les apps ou restés en français) */
  function marqueIt(root) {
    const walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      const v = n.nodeValue;
      if (v && /lentilles/i.test(v) && /mood/i.test(v)) {
        const t = v.replace(/MOOD LENTILLES/g, 'MOOD LENTI').replace(/Mood Lentilles/gi, 'Mood Lenti');
        if (t !== v) n.nodeValue = t;
      }
    }
  }
  function masquerLiensFrance() {
    qa('header a[href*="comment-se-faire-rembourser"], .menu-drawer a[href*="comment-se-faire-rembourser"], .header-wrapper a[href*="comment-se-faire-rembourser"]').forEach(function (a) {
      (a.closest('li') || a).style.display = 'none';
    });
  }
  function initSiteIt() {
    if (!IT_LANG) return;
    masquerLiensFrance();
    marqueIt();
    if (SCRIPT_SRC && document.querySelector('[data-review-id], .jdgm-widget, [class*="jdgm"]')) {
      const s = document.createElement('script');
      s.src = SCRIPT_SRC.replace(/infinite-qty\.js[^/]*$/, 'avis-it.js');
      s.onload = appliquerAvisIt;
      document.head.appendChild(s);
    }
    // Judge.me peut afficher les avis après coup : quelques passages de rattrapage
    let tours = 0;
    const rattrapage = setInterval(function () {
      appliquerAvisIt(); marqueIt();
      qa('.swatches, [class*="swatches-type"]').forEach(function (el) { traduireOptions(el, IT_SWATCHES); });
      if (++tours >= 20) clearInterval(rattrapage);
    }, 1000);
    let attente = null;
    new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () { attente = null; appliquerAvisIt(); masquerLiensFrance(); marqueIt(); }, 80);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ====== boot ====== */
  document.addEventListener('DOMContentLoaded', function(){
    qa('form[action*="/cart/add"]').forEach(wirePdpForm);
    initCartGuards();
    initTraductionOptions();
    initSiteIt();
  });
})();
